export const MEDIA_PIPELINE_PREFIX = 'aws:MediaPipeline'
